import * as React from 'react'
import './table.css'

function Table({ className = '', ...props }) {
  return (
    <div data-slot="table-container" className="table-container">
      <table
        data-slot="table"
        className={`table ${className}`}
        {...props}
      />
    </div>
  )
}

function TableHeader({ className = '', ...props }) {
  return (
    <thead
      data-slot="table-header"
      className={`table-header ${className}`}
      {...props}
    />
  )
}

function TableBody({ className = '', ...props }) {
  return (
    <tbody
      data-slot="table-body"
      className={`table-body ${className}`}
      {...props}
    />
  )
}

function TableFooter({ className = '', ...props }) {
  return (
    <tfoot
      data-slot="table-footer"
      className={`table-footer ${className}`}
      {...props}
    />
  )
}

function TableRow({ className = '', ...props }) {
  return (
    <tr
      data-slot="table-row"
      className={`table-row ${className}`}
      {...props}
    />
  )
}

function TableHead({ className = '', ...props }) {
  return (
    <th
      data-slot="table-head"
      className={`table-head ${className}`}
      {...props}
    />
  )
}

function TableCell({ className = '', ...props }) {
  return (
    <td
      data-slot="table-cell"
      className={`table-cell ${className}`}
      {...props}
    />
  )
}

function TableCaption({ className = '', ...props }) {
  return (
    <caption
      data-slot="table-caption"
      className={`table-caption ${className}`}
      {...props}
    />
  )
}

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
}
